var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-vendor',_vm._b({attrs:{"id-whitelist":_vm.whitelist},on:{"input":function($event){return _vm.$emit('input', $event)}}},'select-vendor',Object.assign({}, _vm.$attrs, _vm.props),false))}
var staticRenderFns = []

export { render, staticRenderFns }